export class AlphabetizedItems<T> {
    public letter: string;
    public items: T[];

    constructor(letter?: string, items?: T[]) {
        this.letter = letter;
        this.items = items || [];
    }
}



// WEBPACK FOOTER //
// ./src/models/alphabetized-items.ts